__turbopack_context__.v({
  "anchorTarget": "renderasset-module-scss-module__boJc9G__anchorTarget",
  "noPadding": "renderasset-module-scss-module__boJc9G__noPadding",
});
